export default __webpack_public_path__ + "static/media/iphone.4f21d5be.png";